import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Logo and Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_validainfo/artifacts/hme4uwyk_NIKA.png" 
                alt="NIKA Logo" 
                className="h-8 w-auto"
              />
              <span className="text-xl font-bold">NIKA</span>
            </div>
            <p className="text-gray-400 text-sm">
              Plataforma líder en validación de datos, verificación de antecedentes y cumplimiento normativo en Colombia.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Servicios</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/validaciones" className="text-gray-400 hover:text-white transition-colors">Validación de Identidad</Link></li>
              <li><Link to="/validaciones" className="text-gray-400 hover:text-white transition-colors">Validación Empresarial</Link></li>
              <li><Link to="/validaciones" className="text-gray-400 hover:text-white transition-colors">Validación Vehicular</Link></li>
              <li><Link to="/validaciones" className="text-gray-400 hover:text-white transition-colors">Monitoreo Continuo</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Empresa</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/nosotros" className="text-gray-400 hover:text-white transition-colors">Nosotros</Link></li>
              <li><Link to="/contacto" className="text-gray-400 hover:text-white transition-colors">Contacto</Link></li>
              <li><Link to="/api" className="text-gray-400 hover:text-white transition-colors">API</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contacto</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-2 text-gray-400">
                <Mail size={16} />
                <span>contacto@nika.co</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-400">
                <Phone size={16} />
                <span>+57 (1) 234-5678</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-400">
                <MapPin size={16} />
                <span>Bogotá, Colombia</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>&copy; 2024 NIKA. Todos los derechos reservados.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacidad" className="hover:text-white transition-colors">Política de Privacidad</Link>
              <Link to="/terminos" className="hover:text-white transition-colors">Términos de Servicio</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;